import { createContext, useContext } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children, user, setUser }) => {
  const login = (userData) => setUser(userData);
  const logout = () => setUser(null);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
